import WorkPermiGrid from './grid.workpermit'

export default WorkPermiGrid